__turbopack_context__.v({
  "container": "banner-medium-module-scss-module__I3dweq__container",
  "item": "banner-medium-module-scss-module__I3dweq__item",
  "skeleton": "banner-medium-module-scss-module__I3dweq__skeleton",
  "title": "banner-medium-module-scss-module__I3dweq__title",
  "title-wrapper": "banner-medium-module-scss-module__I3dweq__title-wrapper",
});
